import { Modal, Button, Form, Dropdown } from "react-bootstrap";
import { useState, useEffect } from "react";
import axios from "../../../axios/axios";
import LoadingOverlay from "react-loading-overlay";
import { message } from "antd";
import "./api-key.css";

const APIKeyModal = ({ apiKeyModal, handleCloseApiKeyModal, uid, source }) => {
    const [visible, setVisible] = useState(false);
    const [copied, setCopied] = useState(false);
    const [apiKey, setApiKey] = useState("");
    const [loading, setLoading] = useState(false);

    const getApiKey = () => {
        setLoading(true);


        axios
            .get(`/get-user-api-keys/${uid}/${source}`)
            .then((res) => {
                setLoading(false);
                if (res.data.status) {
                    setApiKey(res.data.data);
                }
            })
            .catch((err) => {
                setLoading(false);
                console.error(err);
                message.error("Something went wrong!!");
            });
    };
    const handleCopy = () => {
        navigator.clipboard.writeText(apiKey).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };
    useEffect(() => {
        getApiKey();
        console.warn("Call");
    }, []);
    return (
        <LoadingOverlay spinner active={loading} text="Loading...">
        <Modal show={apiKeyModal}>
            <Modal.Header>
                <h4>API Key</h4>
            </Modal.Header>
            
                <Modal.Body>
                    <div>
                    <div className="api-key-box">
                        <label className="api-key-label">Get API Key</label>
                        <div className="api-key-container">
                            <input
                                type={visible ? "text" : "password"}
                                value={apiKey}
                                readOnly
                                className="api-key-input"
                            />
                            <button
                                className="btn btn-primary"
                                onClick={() => setVisible((prev) => !prev)}
                            >
                                {visible ? "Hide" : "View"}
                            </button>
                            <button className="btn btn-primary" onClick={handleCopy}>
                                {copied ? "Copied!" : "Copy"}
                            </button>
                        </div>
                    </div>
                    </div>
                </Modal.Body>
            
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseApiKeyModal}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
        </LoadingOverlay>
    )
}

export default APIKeyModal;